(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/tracking.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/tracking.js');
'use strict';

const {
  findDiffs
} = svs.myProfile.react.shared.helpers;
const {
  backendName,
  checkboxNotifcation
} = svs.myProfile.constants;
const PERSONALIZATION_NAMES = {
  relevantContent: 'relevant content',
  partnerOffers: 'offers and ads (partners)'
};
const SYNDICATE_NAMES = {
  SvS_marketplace_activatedDrawCreated: 'Activated draw',
  SvS_marketplace_sharePurchased: 'Share purchased',
  SvS_marketplace_wagerCancelled: 'Wager cancelled',
  SvS_marketplace_wagerCreated: 'Wager created',
  SvS_marketplace_shareRefunded: 'Share refunded',
  SvS_marketplace_activatedDrawBuyinClosed: 'Buyin closed',
  SvS_marketplace_notifyParticipants_o2k: 'Notify participants',
  SvS_marketplace_notifyGroupMemberRequested_o2k: 'Notify group member',
  SvS_marketplace_wagerCreated_o2k: 'Marketplace wager created',
  SvS_marketplace_shareRefunded_o2k: 'Marketplace share refunded',
  SvS_marketplace_memberAdded: 'Member added',
  SvS_marketplace_memberSelfRemoved: 'Member removed'
};
const TRACKING_NAMES = {
  [backendName.WIN_RESULTS]: 'Correction Mail',
  [backendName.RECURRING_WAGER_REMINDERS]: 'Reminder prolong',
  [backendName.MARKETING_EMAIL]: 'Communication Mail',
  [backendName.MARKETING_SMS]: 'Communication SMS',
  [backendName.MARKETING_LETTER]: 'Communication Letter',
  [backendName.MARKETING_PUSH]: 'Communication Notification App',
  [backendName.SURVEY_PARTICIPATION]: 'Help us be better'
};
const trackEvent = (category, actionName, checked) => {
  if (!actionName && !checked && !category) {
    svs.myProfile.logger.error('Undefined tracking in my profile');
    return;
  }
  let optLabel;
  if (typeof checked === 'string') {
    optLabel = checked;
  } else {
    optLabel = checked ? 'Yes' : 'No';
  }
  const track = {
    category: 'My Profile',
    action: "".concat(category, " - ").concat(actionName),
    opt_label: optLabel
  };
  svs.components.analytics.trackEvent(track);
};
const trackSyndicate = (change, category) => {
  if (!change) {
    svs.myProfile.logger.error('Undefined tracking in my profile');
  }
  const actionName = SYNDICATE_NAMES[change.notificationType];
  const checked = change.transports[0].enabled;
  trackEvent(category, actionName, checked);
};
const trackCheckbox = (change, category) => {
  const actionName = TRACKING_NAMES[change === null || change === void 0 ? void 0 : change.key];
  const checked = change === null || change === void 0 ? void 0 : change.value;
  trackEvent(category, actionName, checked);
};
const trackNotifcation = (checkboxName, change) => {
  const actionName = 'Correction Numbergames';
  let label;
  switch (checkboxName) {
    case checkboxNotifcation.TRACK_MAIL:
      if (change) {
        label = 'Yes';
      } else {
        label = 'No';
      }
      break;
    case checkboxNotifcation.TRACK_LINK:
      label = 'link';
      break;
    case checkboxNotifcation.TRACK_WIN:
      label = 'winning mail';
      break;
    default:
      svs.myProfile.logger.warn('Undefined list in trackListChanges');
      break;
  }
  const track = {
    category: 'My Profile',
    action: actionName,
    opt_label: label
  };
  svs.components.analytics.trackEvent(track);
};

const trackPersonlization = (key, value, category) => {
  const formatedKey = PERSONALIZATION_NAMES[key];
  trackEvent(category, formatedKey, value);
};

const trackAppNotifcation = (change, category) => {
  var _change$value, _change$value2;
  const checked = change === null || change === void 0 || (_change$value = change.value) === null || _change$value === void 0 ? void 0 : _change$value.active;
  const productName = change === null || change === void 0 || (_change$value2 = change.value) === null || _change$value2 === void 0 ? void 0 : _change$value2.productName;
  trackEvent(category, productName, checked);
};
const trackAppPauseNotifcation = (pauseAmount, pauseStatus, category) => {
  trackEvent(category, pauseStatus, pauseAmount);
};

const trackListChanges = (newList, oldList, settings, category) => {
  const listOfChanges = Array.isArray(newList) ? newList : findDiffs(newList, oldList);
  listOfChanges.forEach(change => {
    switch (settings) {
      case 'syndicate':
        trackSyndicate(change, category);
        break;
      case 'communication':
        trackCheckbox(change, category);
        break;
      case 'notifications':
        trackCheckbox(change, category);
        break;
      case 'app-notifications':
        trackAppNotifcation(change, category);
        break;
      default:
        svs.myProfile.logger.warn('Undefined list in trackListChanges');
        break;
    }
  });
};
svs.myProfile.react.shared.tracking = {
  trackListChanges,
  trackPersonlization,
  trackAppNotifcation,
  trackNotifcation,
  trackAppPauseNotifcation
};

 })(window);